import { createWriteApiHook } from "../../mutation";

/**
 * Method-level POST hook: `.mutate(body)` posts to `serviceName`, resolves the
 * full envelope for the toast pipeline, and auto-invalidates the entity's
 * cached queries. `idRequired: true` flips the variables to `{ id, body }`
 * targeting `serviceName/:id`.
 *
 * @example
 * ```typescript
 * const create = usePostApi<UserResponse, CreateUserRequest>({
 *   serviceName: API_ROUTES.USER.base,
 *   showSuccessToast: true,
 * });
 * create.mutate(body); // POST /v1/users → invalidates ["users"]
 *
 * // manual messaging in the component
 * const register = usePostApi<UserResponse, CreateUserRequest>({
 *   serviceName: API_ROUTES.USER.base,
 *   withoutToastMessage: true,
 *   onSuccess: (user, message) => setBanner(message),
 * });
 * ```
 */
export const usePostApi = createWriteApiHook("post");
